/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: k4MoYHGY6d3NVAoA3aDDg2
// Component: lus6OgZNeC63

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import {
  executePlasmicDataOp,
  usePlasmicDataOp,
  usePlasmicInvalidate
} from "@plasmicapp/react-web/lib/data-sources";

import { SupabaseDataProvider } from "@/components/SupabaseDataProvider"; // plasmic-import: yj_J6waDJ0RW/codeComponent
import { AntdModal } from "@plasmicpkgs/antd5/skinny/registerModal";
import { OptimizedSupabaseImage } from "@/components/OptimizedSupabaseImage"; // plasmic-import: yMIKZpjcjFwA/codeComponent
import { AntdButton } from "@plasmicpkgs/antd5/skinny/registerButton";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/styleTokensProvider


import sty from "./PlasmicNotificationCenter2.module.css"; // plasmic-import: lus6OgZNeC63/css

createPlasmicElementProxy;

export type PlasmicNotificationCenter2__VariantMembers = {};
export type PlasmicNotificationCenter2__VariantsArgs = {};
type VariantPropType = keyof PlasmicNotificationCenter2__VariantsArgs;
export const PlasmicNotificationCenter2__VariantProps =
  new Array<VariantPropType>();

export type PlasmicNotificationCenter2__ArgsType = {};
type ArgPropType = keyof PlasmicNotificationCenter2__ArgsType;
export const PlasmicNotificationCenter2__ArgProps = new Array<ArgPropType>();

export type PlasmicNotificationCenter2__OverridesType = {
  root?: Flex__<"div">;
  supabaseDataProviderTable?: Flex__<typeof SupabaseDataProvider>;
  modal?: Flex__<typeof AntdModal>;
  h4?: Flex__<"h4">;
  optimizedSupabaseImage?: Flex__<typeof OptimizedSupabaseImage>;
  h2?: Flex__<"h2">;
  h1?: Flex__<"h1">;
};

export interface DefaultNotificationCenter2Props {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicNotificationCenter2__RenderFunc(props: {
  variants: PlasmicNotificationCenter2__VariantsArgs;
  args: PlasmicNotificationCenter2__ArgsType;
  overrides: PlasmicNotificationCenter2__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "modal.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return (() => {
                function filterNotInLastHour(items) {
                  console.log("I ran");
                  const oneHourAgo = Date.now() - 60 * 60 * 1000 * 2;
                  return items.filter(item => {
                    if (!item.delay_date) {
                      return true;
                    }
                    const delayTime = new Date(item.delay_date).getTime();
                    return delayTime < oneHourAgo;
                  });
                }
                return (
                  filterNotInLastHour($ctx.get_unread_notifications).length > 0
                );
              })();
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return false;
              }
              throw e;
            }
          })()
      }
    ],
    [$props, $ctx, $refs]
  );

  const $globalActions = useGlobalActions?.();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const dataSourcesCtx = usePlasmicDataSourceContext();
  const plasmicInvalidate = usePlasmicInvalidate();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      {(() => {
        try {
          return [
            "15827eab-1f98-466a-95ee-cf7a0ef04612",
            "d96f10c3-02c4-44a1-b39b-683b2224f95a",
            "0d3d41db-91ad-41ea-bef4-925bb1acad04",
            "84f87866-9dc9-4e9d-a946-0f0ca2dfe747",
            "b1574f4b-fed4-4c6e-9379-cfcb7e87a52e"
          ].includes($ctx.layout?.uuid);
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <div className={classNames("all", sty.freeBox__l39Kn)}>
          <SupabaseDataProvider
            data-plasmic-name={"supabaseDataProviderTable"}
            data-plasmic-override={overrides.supabaseDataProviderTable}
            alwaysClient={false}
            blockingLoad={false}
            className={classNames(
              "__wab_instance",
              sty.supabaseDataProviderTable
            )}
            dataName={"get_unread_notifications"}
            match={
              "status_id=in.(1,2)&phones.reports.status_id=neq.5&phones.reports.status_id=neq.12"
            }
            selectQuery={
              "id,created_at, delay_date,...parts_inventory(part_name, stock), ...phones(...enum_models(model:name),reports(status_id,id)),...technicians(technician:name,picture_url), status_id, phone_id"
            }
            tableName={"parts_queue"}
          >
            <DataCtxReader__>
              {$ctx =>
                (() => {
                  const child$Props = {
                    className: classNames("__wab_instance", sty.modal),
                    defaultStylesClassName: classNames(
                      "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
                      "plasmic_default_styles",
                      "plasmic_mixins",
                      styleTokensClassNames
                    ),
                    modalScopeClassName: sty["modal__modal"],
                    onOpenChange: async (...eventArgs: any) => {
                      generateStateOnChangeProp($state, [
                        "modal",
                        "open"
                      ]).apply(null, eventArgs);
                    },
                    open: generateStateValueProp($state, ["modal", "open"]),
                    title: (
                      <h1
                        data-plasmic-name={"h1"}
                        data-plasmic-override={overrides.h1}
                        className={classNames(
                          "all",
                          "h1",
                          "h1__k4MoY",
                          "__wab_text",
                          sty.h1
                        )}
                      >
                        {"Notifications"}
                      </h1>
                    ),
                    trigger: null,
                    width: "70%"
                  };
                  initializeCodeComponentStates(
                    $state,
                    [
                      {
                        name: "open",
                        plasmicStateName: "modal.open"
                      }
                    ],
                    [],
                    undefined ?? {},
                    child$Props
                  );
                  initializePlasmicStates(
                    $state,
                    [
                      {
                        name: "modal.open",
                        initFunc: ({ $props, $state, $queries, $q }) =>
                          (() => {
                            try {
                              return (() => {
                                function filterNotInLastHour(items) {
                                  console.log("I ran");
                                  const oneHourAgo =
                                    Date.now() - 60 * 60 * 1000 * 2;
                                  return items.filter(item => {
                                    if (!item.delay_date) {
                                      return true;
                                    }
                                    const delayTime = new Date(
                                      item.delay_date
                                    ).getTime();
                                    return delayTime < oneHourAgo;
                                  });
                                }
                                return (
                                  filterNotInLastHour(
                                    $ctx.get_unread_notifications
                                  ).length > 0
                                );
                              })();
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return false;
                              }
                              throw e;
                            }
                          })()
                      }
                    ],
                    []
                  );
                  return (
                    <AntdModal
                      data-plasmic-name={"modal"}
                      data-plasmic-override={overrides.modal}
                      {...child$Props}
                    >
                      <div className={classNames("all", sty.freeBox__uTdj7)}>
                        {(_par =>
                          !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                          (() => {
                            try {
                              return (() => {
                                function filterNotInLastHour(items) {
                                  const oneHourAgo =
                                    Date.now() - 60 * 60 * 1000 * 2;
                                  return items.filter(item => {
                                    if (!item.delay_date) {
                                      return true;
                                    }
                                    const delayTime = new Date(
                                      item.delay_date
                                    ).getTime();
                                    return delayTime < oneHourAgo;
                                  });
                                }
                                return filterNotInLastHour(
                                  $ctx.get_unread_notifications
                                );
                              })();
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return [];
                              }
                              throw e;
                            }
                          })()
                        ).map((__plasmic_item_0, __plasmic_idx_0) => {
                          const currentItem = __plasmic_item_0;
                          const currentIndex = __plasmic_idx_0;
                          return (
                            <div
                              className={classNames("all", sty.freeBox__at0Mn)}
                              key={currentIndex}
                              style={(() => {
                                try {
                                  return (() => {
                                    let dayNumber = currentItem.status_id ?? 0;
                                    let dayName = "";
                                    switch (dayNumber) {
                                      case 1:
                                        dayName = {};
                                        break;
                                      case 2:
                                        dayName = {
                                          backgroundColor: "rgb(255,70,70)"
                                        };
                                        break;
                                      default:
                                        dayName = {};
                                    }
                                    return dayName;
                                  })();
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return undefined;
                                  }
                                  throw e;
                                }
                              })()}
                            >
                              <div
                                className={classNames(
                                  "all",
                                  sty.freeBox___2234J
                                )}
                              >
                                <h4
                                  data-plasmic-name={"h4"}
                                  data-plasmic-override={overrides.h4}
                                  className={classNames(
                                    "all",
                                    "h4",
                                    "h4__k4MoY",
                                    "__wab_text",
                                    sty.h4
                                  )}
                                >
                                  <React.Fragment>
                                    {(() => {
                                      try {
                                        return currentItem.technician;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return "";
                                        }
                                        throw e;
                                      }
                                    })()}
                                  </React.Fragment>
                                </h4>
                                <OptimizedSupabaseImage
                                  data-plasmic-name={"optimizedSupabaseImage"}
                                  data-plasmic-override={
                                    overrides.optimizedSupabaseImage
                                  }
                                  alt={"Descriptive image text"}
                                  className={classNames(
                                    "__wab_instance",
                                    sty.optimizedSupabaseImage
                                  )}
                                  height={80}
                                  src={(() => {
                                    try {
                                      return currentItem.picture_url;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return undefined;
                                      }
                                      throw e;
                                    }
                                  })()}
                                  width={80}
                                />
                              </div>
                              <div
                                className={classNames(
                                  "all",
                                  sty.freeBox__uaR54
                                )}
                              >
                                <h2
                                  data-plasmic-name={"h2"}
                                  data-plasmic-override={overrides.h2}
                                  className={classNames(
                                    "all",
                                    "h2",
                                    "h2__k4MoY",
                                    "__wab_text",
                                    sty.h2
                                  )}
                                >
                                  <React.Fragment>
                                    {(() => {
                                      try {
                                        return (() => {
                                          let dayNumber =
                                            currentItem.status_id ?? 0;
                                          switch (dayNumber) {
                                            case 1:
                                              return "Part Request";
                                            case 2:
                                              return "Pending for parts";
                                            default:
                                              return "Invalid day";
                                          }
                                        })();
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return "Modal content";
                                        }
                                        throw e;
                                      }
                                    })()}
                                  </React.Fragment>
                                </h2>
                                <div
                                  className={classNames(
                                    "all",
                                    "__wab_text",
                                    sty.text__iAbIa
                                  )}
                                >
                                  <div
                                    className={"__wab_expr_html_text"}
                                    dangerouslySetInnerHTML={{
                                      __html: (() => {
                                        try {
                                          return `Wants a <span style= 'font-size: 25px; font-weight: bold; color: black'>${currentItem.part_name}</span> for <strong>${currentItem.model}</strong>`;
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return "Modal content";
                                          }
                                          throw e;
                                        }
                                      })()
                                    }}
                                  />
                                </div>
                              </div>
                              <div
                                className={classNames(
                                  "all",
                                  sty.freeBox__vTzEk
                                )}
                              >
                                <div
                                  className={classNames(
                                    "all",
                                    "__wab_text",
                                    sty.text__sk7F
                                  )}
                                >
                                  <React.Fragment>
                                    {(() => {
                                      try {
                                        return new Date(
                                          currentItem.created_at
                                        ).toLocaleString();
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return "";
                                        }
                                        throw e;
                                      }
                                    })()}
                                  </React.Fragment>
                                </div>
                                <div
                                  className={classNames(
                                    "all",
                                    sty.freeBox___22TO2
                                  )}
                                >
                                  {(() => {
                                    try {
                                      return (
                                        currentItem.stock <= 0 &&
                                        currentItem.reports.filter(
                                          item => item.status_id == 13
                                        ) == 0
                                      );
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return false;
                                      }
                                      throw e;
                                    }
                                  })() ? (
                                    <AntdButton
                                      className={classNames(
                                        "__wab_instance",
                                        sty.button__jTmLq
                                      )}
                                      disabled={currentItem.reports.length == 0}
                                      onClick={async () => {
                                        const $steps = {};

                                        $steps["invokeGlobalAction"] = true
                                          ? (() => {
                                              const actionArgs = {
                                                args: [
                                                  "reports",
                                                  (() => {
                                                    try {
                                                      return {
                                                        eq: {
                                                          id: currentItem.reports.filter(
                                                            item =>
                                                              item.status_id !=
                                                              13
                                                          )[0].id
                                                        }
                                                      };
                                                    } catch (e) {
                                                      if (
                                                        e instanceof
                                                          TypeError ||
                                                        e?.plasmicType ===
                                                          "PlasmicUndefinedDataError"
                                                      ) {
                                                        return undefined;
                                                      }
                                                      throw e;
                                                    }
                                                  })(),
                                                  { status_id: 13 },
                                                  true
                                                ]
                                              };
                                              return $globalActions[
                                                "SupabaseActions.update"
                                              ]?.apply(null, [
                                                ...actionArgs.args
                                              ]);
                                            })()
                                          : undefined;
                                        if (
                                          $steps["invokeGlobalAction"] !=
                                            null &&
                                          typeof $steps[
                                            "invokeGlobalAction"
                                          ] === "object" &&
                                          typeof $steps["invokeGlobalAction"]
                                            .then === "function"
                                        ) {
                                          $steps["invokeGlobalAction"] =
                                            await $steps["invokeGlobalAction"];
                                        }

                                        $steps["runCode"] = true
                                          ? (() => {
                                              const actionArgs = {
                                                customFunction: async () => {
                                                  return (() => {
                                                    function openFullscreenPopup(
                                                      text = "popup"
                                                    ) {
                                                      const popup = window.open(
                                                        "",
                                                        "fullscreenPopup",
                                                        "width=800,height=600,resizable=yes,scrollbars=no"
                                                      );
                                                      if (!popup) return;
                                                      popup.document.write(`
    <html>
      <head>
        <title>Popup</title>
        <style>
          html, body {
            margin: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            background: white;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
          }
          .text {
            color: black;
            font-weight: bold;
            text-transform: uppercase;
            font-size: 10vw; /* auto scales with viewport */
            text-align: center;
            line-height: 1;
            user-select: none;
          }
        </style>
      </head>
      <body>
        <div class="text">${text}</div>
      </body>
    </html>
  `);
                                                      popup.document.close();
                                                    }
                                                    return openFullscreenPopup(
                                                      `Waiting ${currentItem.part_name}`
                                                    );
                                                  })();
                                                }
                                              };
                                              return (({ customFunction }) => {
                                                return customFunction();
                                              })?.apply(null, [actionArgs]);
                                            })()
                                          : undefined;
                                        if (
                                          $steps["runCode"] != null &&
                                          typeof $steps["runCode"] ===
                                            "object" &&
                                          typeof $steps["runCode"].then ===
                                            "function"
                                        ) {
                                          $steps["runCode"] =
                                            await $steps["runCode"];
                                        }

                                        $steps["refreshData"] = true
                                          ? (() => {
                                              const actionArgs = {
                                                queryInvalidation: [
                                                  "plasmic_refresh_all"
                                                ]
                                              };
                                              return (async ({
                                                queryInvalidation
                                              }) => {
                                                if (!queryInvalidation) {
                                                  return;
                                                }
                                                await plasmicInvalidate(
                                                  queryInvalidation
                                                );
                                              })?.apply(null, [actionArgs]);
                                            })()
                                          : undefined;
                                        if (
                                          $steps["refreshData"] != null &&
                                          typeof $steps["refreshData"] ===
                                            "object" &&
                                          typeof $steps["refreshData"].then ===
                                            "function"
                                        ) {
                                          $steps["refreshData"] =
                                            await $steps["refreshData"];
                                        }
                                      }}
                                      type={"primary"}
                                    >
                                      <div
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text__vtz2R
                                        )}
                                      >
                                        <div
                                          className={"__wab_expr_html_text"}
                                          dangerouslySetInnerHTML={{
                                            __html: (() => {
                                              try {
                                                return (
                                                  "Waiting for part" +
                                                  (currentItem.reports.length ==
                                                  0
                                                    ? "<br>No real report"
                                                    : "")
                                                );
                                              } catch (e) {
                                                if (
                                                  e instanceof TypeError ||
                                                  e?.plasmicType ===
                                                    "PlasmicUndefinedDataError"
                                                ) {
                                                  return "Waiting For Part";
                                                }
                                                throw e;
                                              }
                                            })()
                                          }}
                                        />
                                      </div>
                                    </AntdButton>
                                  ) : null}
                                  {(() => {
                                    try {
                                      return currentItem.stock > 0;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return true;
                                      }
                                      throw e;
                                    }
                                  })() ? (
                                    <AntdButton
                                      className={classNames(
                                        "__wab_instance",
                                        sty.button__o7Xdh
                                      )}
                                      onClick={async () => {
                                        const $steps = {};

                                        $steps["invokeGlobalAction"] = true
                                          ? (() => {
                                              const actionArgs = {
                                                args: [
                                                  "parts_queue",
                                                  (() => {
                                                    try {
                                                      return {
                                                        eq: {
                                                          id: currentItem.id
                                                        }
                                                      };
                                                    } catch (e) {
                                                      if (
                                                        e instanceof
                                                          TypeError ||
                                                        e?.plasmicType ===
                                                          "PlasmicUndefinedDataError"
                                                      ) {
                                                        return undefined;
                                                      }
                                                      throw e;
                                                    }
                                                  })(),
                                                  { status_id: 10 },
                                                  true
                                                ]
                                              };
                                              return $globalActions[
                                                "SupabaseActions.update"
                                              ]?.apply(null, [
                                                ...actionArgs.args
                                              ]);
                                            })()
                                          : undefined;
                                        if (
                                          $steps["invokeGlobalAction"] !=
                                            null &&
                                          typeof $steps[
                                            "invokeGlobalAction"
                                          ] === "object" &&
                                          typeof $steps["invokeGlobalAction"]
                                            .then === "function"
                                        ) {
                                          $steps["invokeGlobalAction"] =
                                            await $steps["invokeGlobalAction"];
                                        }

                                        $steps["refreshData"] = true
                                          ? (() => {
                                              const actionArgs = {
                                                queryInvalidation: [
                                                  "plasmic_refresh_all"
                                                ]
                                              };
                                              return (async ({
                                                queryInvalidation
                                              }) => {
                                                if (!queryInvalidation) {
                                                  return;
                                                }
                                                await plasmicInvalidate(
                                                  queryInvalidation
                                                );
                                              })?.apply(null, [actionArgs]);
                                            })()
                                          : undefined;
                                        if (
                                          $steps["refreshData"] != null &&
                                          typeof $steps["refreshData"] ===
                                            "object" &&
                                          typeof $steps["refreshData"].then ===
                                            "function"
                                        ) {
                                          $steps["refreshData"] =
                                            await $steps["refreshData"];
                                        }
                                      }}
                                      type={"primary"}
                                    >
                                      <div
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text__r47Ve
                                        )}
                                      >
                                        {"Approve"}
                                      </div>
                                    </AntdButton>
                                  ) : null}
                                  {(() => {
                                    try {
                                      return currentItem.stock == null;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return true;
                                      }
                                      throw e;
                                    }
                                  })() ? (
                                    <AntdButton
                                      className={classNames(
                                        "__wab_instance",
                                        sty.button__tqH0F
                                      )}
                                      danger={true}
                                      onClick={async () => {
                                        const $steps = {};

                                        $steps["invokeGlobalAction"] = true
                                          ? (() => {
                                              const actionArgs = {
                                                args: [
                                                  "parts_queue",
                                                  (() => {
                                                    try {
                                                      return {
                                                        eq: {
                                                          id: currentItem.id
                                                        }
                                                      };
                                                    } catch (e) {
                                                      if (
                                                        e instanceof
                                                          TypeError ||
                                                        e?.plasmicType ===
                                                          "PlasmicUndefinedDataError"
                                                      ) {
                                                        return undefined;
                                                      }
                                                      throw e;
                                                    }
                                                  })(),
                                                  (() => {
                                                    try {
                                                      return {
                                                        delay_date:
                                                          new Date().toISOString()
                                                      };
                                                    } catch (e) {
                                                      if (
                                                        e instanceof
                                                          TypeError ||
                                                        e?.plasmicType ===
                                                          "PlasmicUndefinedDataError"
                                                      ) {
                                                        return {
                                                          status_id: 10
                                                        };
                                                      }
                                                      throw e;
                                                    }
                                                  })(),
                                                  true
                                                ]
                                              };
                                              return $globalActions[
                                                "SupabaseActions.update"
                                              ]?.apply(null, [
                                                ...actionArgs.args
                                              ]);
                                            })()
                                          : undefined;
                                        if (
                                          $steps["invokeGlobalAction"] !=
                                            null &&
                                          typeof $steps[
                                            "invokeGlobalAction"
                                          ] === "object" &&
                                          typeof $steps["invokeGlobalAction"]
                                            .then === "function"
                                        ) {
                                          $steps["invokeGlobalAction"] =
                                            await $steps["invokeGlobalAction"];
                                        }

                                        $steps["goToPhoneParts"] = true
                                          ? (() => {
                                              const actionArgs = {
                                                destination: `/phone-parts`
                                              };
                                              return (({ destination }) => {
                                                if (
                                                  typeof destination ===
                                                    "string" &&
                                                  destination.startsWith("#")
                                                ) {
                                                  document
                                                    .getElementById(
                                                      destination.substr(1)
                                                    )
                                                    .scrollIntoView({
                                                      behavior: "smooth"
                                                    });
                                                } else {
                                                  __nextRouter?.push(
                                                    destination
                                                  );
                                                }
                                              })?.apply(null, [actionArgs]);
                                            })()
                                          : undefined;
                                        if (
                                          $steps["goToPhoneParts"] != null &&
                                          typeof $steps["goToPhoneParts"] ===
                                            "object" &&
                                          typeof $steps["goToPhoneParts"]
                                            .then === "function"
                                        ) {
                                          $steps["goToPhoneParts"] =
                                            await $steps["goToPhoneParts"];
                                        }
                                      }}
                                    >
                                      <div
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text__vq1NP
                                        )}
                                      >
                                        {"Register Piece"}
                                      </div>
                                    </AntdButton>
                                  ) : null}
                                  {(() => {
                                    try {
                                      return currentItem.stock != null;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return true;
                                      }
                                      throw e;
                                    }
                                  })() ? (
                                    <AntdButton
                                      className={classNames(
                                        "__wab_instance",
                                        sty.button__jElQ5
                                      )}
                                      danger={true}
                                      onClick={async () => {
                                        const $steps = {};

                                        $steps["invokeGlobalAction"] = true
                                          ? (() => {
                                              const actionArgs = {
                                                args: [
                                                  "parts_queue",
                                                  (() => {
                                                    try {
                                                      return {
                                                        eq: {
                                                          id: currentItem.id
                                                        }
                                                      };
                                                    } catch (e) {
                                                      if (
                                                        e instanceof
                                                          TypeError ||
                                                        e?.plasmicType ===
                                                          "PlasmicUndefinedDataError"
                                                      ) {
                                                        return undefined;
                                                      }
                                                      throw e;
                                                    }
                                                  })(),
                                                  (() => {
                                                    try {
                                                      return {
                                                        delay_date:
                                                          new Date().toISOString()
                                                      };
                                                    } catch (e) {
                                                      if (
                                                        e instanceof
                                                          TypeError ||
                                                        e?.plasmicType ===
                                                          "PlasmicUndefinedDataError"
                                                      ) {
                                                        return {
                                                          status_id: 10
                                                        };
                                                      }
                                                      throw e;
                                                    }
                                                  })(),
                                                  true
                                                ]
                                              };
                                              return $globalActions[
                                                "SupabaseActions.update"
                                              ]?.apply(null, [
                                                ...actionArgs.args
                                              ]);
                                            })()
                                          : undefined;
                                        if (
                                          $steps["invokeGlobalAction"] !=
                                            null &&
                                          typeof $steps[
                                            "invokeGlobalAction"
                                          ] === "object" &&
                                          typeof $steps["invokeGlobalAction"]
                                            .then === "function"
                                        ) {
                                          $steps["invokeGlobalAction"] =
                                            await $steps["invokeGlobalAction"];
                                        }

                                        $steps["refreshData"] = true
                                          ? (() => {
                                              const actionArgs = {
                                                queryInvalidation: [
                                                  "plasmic_refresh_all"
                                                ]
                                              };
                                              return (async ({
                                                queryInvalidation
                                              }) => {
                                                if (!queryInvalidation) {
                                                  return;
                                                }
                                                await plasmicInvalidate(
                                                  queryInvalidation
                                                );
                                              })?.apply(null, [actionArgs]);
                                            })()
                                          : undefined;
                                        if (
                                          $steps["refreshData"] != null &&
                                          typeof $steps["refreshData"] ===
                                            "object" &&
                                          typeof $steps["refreshData"].then ===
                                            "function"
                                        ) {
                                          $steps["refreshData"] =
                                            await $steps["refreshData"];
                                        }
                                      }}
                                    >
                                      <div
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text__rwL83
                                        )}
                                      >
                                        <React.Fragment>
                                          {(() => {
                                            try {
                                              return "Remind me in 4 hours";
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return "Remind me in 1 hour";
                                              }
                                              throw e;
                                            }
                                          })()}
                                        </React.Fragment>
                                      </div>
                                    </AntdButton>
                                  ) : null}
                                  <AntdButton
                                    className={classNames(
                                      "__wab_instance",
                                      sty.button__aNlJh
                                    )}
                                    danger={true}
                                    onClick={async () => {
                                      const $steps = {};

                                      $steps["invokeGlobalAction"] = true
                                        ? (() => {
                                            const actionArgs = {
                                              args: [
                                                "parts_queue",
                                                (() => {
                                                  try {
                                                    return {
                                                      eq: {
                                                        id: currentItem.id
                                                      }
                                                    };
                                                  } catch (e) {
                                                    if (
                                                      e instanceof TypeError ||
                                                      e?.plasmicType ===
                                                        "PlasmicUndefinedDataError"
                                                    ) {
                                                      return undefined;
                                                    }
                                                    throw e;
                                                  }
                                                })(),
                                                true
                                              ]
                                            };
                                            return $globalActions[
                                              "SupabaseActions.delete"
                                            ]?.apply(null, [
                                              ...actionArgs.args
                                            ]);
                                          })()
                                        : undefined;
                                      if (
                                        $steps["invokeGlobalAction"] != null &&
                                        typeof $steps["invokeGlobalAction"] ===
                                          "object" &&
                                        typeof $steps["invokeGlobalAction"]
                                          .then === "function"
                                      ) {
                                        $steps["invokeGlobalAction"] =
                                          await $steps["invokeGlobalAction"];
                                      }

                                      $steps["refreshData"] = true
                                        ? (() => {
                                            const actionArgs = {
                                              queryInvalidation: [
                                                "plasmic_refresh_all"
                                              ]
                                            };
                                            return (async ({
                                              queryInvalidation
                                            }) => {
                                              if (!queryInvalidation) {
                                                return;
                                              }
                                              await plasmicInvalidate(
                                                queryInvalidation
                                              );
                                            })?.apply(null, [actionArgs]);
                                          })()
                                        : undefined;
                                      if (
                                        $steps["refreshData"] != null &&
                                        typeof $steps["refreshData"] ===
                                          "object" &&
                                        typeof $steps["refreshData"].then ===
                                          "function"
                                      ) {
                                        $steps["refreshData"] =
                                          await $steps["refreshData"];
                                      }
                                    }}
                                    type={"default"}
                                  >
                                    <div
                                      className={classNames(
                                        "all",
                                        "__wab_text",
                                        sty.text__iVuQi
                                      )}
                                    >
                                      {"X"}
                                    </div>
                                  </AntdButton>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </AntdModal>
                  );
                })()
              }
            </DataCtxReader__>
          </SupabaseDataProvider>
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "supabaseDataProviderTable",
    "modal",
    "h4",
    "optimizedSupabaseImage",
    "h2",
    "h1"
  ],
  supabaseDataProviderTable: [
    "supabaseDataProviderTable",
    "modal",
    "h4",
    "optimizedSupabaseImage",
    "h2",
    "h1"
  ],
  modal: ["modal", "h4", "optimizedSupabaseImage", "h2", "h1"],
  h4: ["h4"],
  optimizedSupabaseImage: ["optimizedSupabaseImage"],
  h2: ["h2"],
  h1: ["h1"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  supabaseDataProviderTable: typeof SupabaseDataProvider;
  modal: typeof AntdModal;
  h4: "h4";
  optimizedSupabaseImage: typeof OptimizedSupabaseImage;
  h2: "h2";
  h1: "h1";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNotificationCenter2__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNotificationCenter2__VariantsArgs;
    args?: PlasmicNotificationCenter2__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicNotificationCenter2__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicNotificationCenter2__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicNotificationCenter2__ArgProps,
          internalVariantPropNames: PlasmicNotificationCenter2__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicNotificationCenter2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNotificationCenter2";
  } else {
    func.displayName = `PlasmicNotificationCenter2.${nodeName}`;
  }
  return func;
}

export const PlasmicNotificationCenter2 = Object.assign(
  // Top-level PlasmicNotificationCenter2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    supabaseDataProviderTable: makeNodeComponent("supabaseDataProviderTable"),
    modal: makeNodeComponent("modal"),
    h4: makeNodeComponent("h4"),
    optimizedSupabaseImage: makeNodeComponent("optimizedSupabaseImage"),
    h2: makeNodeComponent("h2"),
    h1: makeNodeComponent("h1"),

    // Metadata about props expected for PlasmicNotificationCenter2
    internalVariantProps: PlasmicNotificationCenter2__VariantProps,
    internalArgProps: PlasmicNotificationCenter2__ArgProps
  }
);

export default PlasmicNotificationCenter2;
/* prettier-ignore-end */
